import { createContext, useContext } from 'react'
import { useQuery } from '@tanstack/react-query'
import { api } from '../lib/api'

export interface User {
  id: string
  email: string
  name: string
  role: 'admin' | 'creator' | 'viewer'
}

interface AuthContextType {
  user: User | null
  isLoading: boolean
  isAuthenticated: boolean
  error: Error | null
}

export const AuthContext = createContext<AuthContextType>({
  user: null,
  isLoading: true,
  isAuthenticated: false,
  error: null,
})

export function useAuth() {
  return useContext(AuthContext)
}

export function useAuthQuery() {
  return useQuery({
    queryKey: ['auth', 'user'],
    queryFn: async () => {
      // Check if we can access the API (auth is handled by Cloudflare Access)
      const features = await api.getFeatures()
      // If we got here, we're authenticated
      // In a real app, you'd have a /api/me endpoint
      return {
        id: 'current-user',
        email: 'user@calliope.ai',
        name: 'User',
        role: 'admin' as const,
        features,
      }
    },
    retry: false,
    staleTime: 1000 * 60 * 5, // 5 minutes
  })
}
